<div [ngClass]="bgColor">
    <label class="tab-btn" [id]="btn.id" *ngFor="let btn of buttons; let i = index" (click)="btn.tabEvent ? btn.tabEvent(btn.functionContext) : ''">
        <input type="radio" [name]="name" [checked]="indexSelected == i ? true : false" [disabled]="btn.disabled" [value]="btn.title" (change)="onChangeTab(i)">
        <label class="tab-text">
            {{ btn.title }}</label>
    </label>
</div>
